var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-markdown',{staticClass:"markdown-body",attrs:{"source":_vm.source,"source-map":false,"id":_vm.elementId}})}
var staticRenderFns = []

export { render, staticRenderFns }